export default "__VITE_ASSET__71568d4a__"